import React from 'react';
const contents = [{
  emoji: '📘',
  title: '6 Bände Grundschule',
  desc: 'Komplette Jahresplanungen für Klasse 1 bis 6: Bewegungsformen, Spiele, Koordination, Turnen, Leichtathletik, Teamaufgaben, Sicherheit und Reflexion.'
}, {
  emoji: '📐',
  title: '6 Bände Sekundarstufe',
  desc: 'Jahresplanungen für Klasse 7 bis 12: Technik, Taktik, Mannschaftssport, Fitness, Turnen, Gesundheit, Trainingslehre, Fair Play und Bewertung.'
}, {
  emoji: '⚽',
  title: 'Über 480 fertige Sportstunden',
  desc: 'Jede Stunde klar aufgebaut: Thema, Lernziel, Material, Aufwärmung, Hauptteil, Varianten, Differenzierung, Sicherheit und Reflexion.'
}, {
  emoji: '📊',
  title: 'Bewertung & Beobachtung',
  desc: 'Praktische Hilfen für faire Sportnoten: Beobachtungsbögen, Leistungsraster, Mitarbeit, Fair Play, Technik und Lernfortschritt.'
}, {
  emoji: '🏃',
  title: 'Übungen, Spiele & Stationen',
  desc: 'Laufspiele, Koordination, Bewegungslandschaften, Teamspiele, Ballspiele, Fitness-Zirkel, Turnstationen und Leichtathletik-Aufgaben.'
}, {
  emoji: '📝',
  title: 'Arbeitsblätter & Druckvorlagen',
  desc: 'Ideal für Theoriephasen, Ersatzstunden, Reflexion, Selbstbewertung, Gesundheitswissen, Sportregeln und Schülerfeedback.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 Was enthält SPORTUNTERRICHT FERTIG?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-5">
          {contents.map((item, i) => <div key={i} className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-6">
              <div className="text-4xl sm:text-5xl mb-4" data-id="element-7">{item.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-text-sec text-base" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}